import { render, staticRenderFns } from "./SkillTests.vue?vue&type=template&id=3e5dc136"
import script from "./SkillTests.vue?vue&type=script&lang=js"
export * from "./SkillTests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports